import { PromotionAction } from "@3gaam/api/types/consultancy";
import { CSSProperties } from "react";
import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";

type Actions =
  | "goToSearchPage"
  | "goToHall"
  | "goToCounselorPage"
  | "goToPackagePage"
  | "goToBuyPage"
  | "goToFieldPage"
  | "onPromotionClick"
  | "goToMyCounselorsPage"
  | "goToCategories"
  | "onServiceClick"
  | "goToCounselorChatPage"
  | "getCounselorPackageSlug"
  | "backToPrevious";

type ActionHandlers = Record<Actions, (...params: any) => void>;

type GetData = "getField";
type GetDataHandlers = Record<GetData, (...params: any) => any>;

type LinkComponent = ({
  children,
  hrefProps,
  className,
}: {
  children: ({}: { onClick: () => void }) => React.ReactNode;
  hrefProps: HrefProps;
  className?: string;
  style?: CSSProperties;
}) => React.ReactElement;

export type PromotionActionWithTitle = PromotionAction & { Title?: string };

export type HrefProps =
  | { page: "hall"; title?: string }
  | {
      page: "search";
      searchQuery: string | undefined | null;
      title?: string;
    }
  | {
      page: "counselor";
      counselorSlug: string | undefined | null;
      packageSlug?: string | undefined | null;
      title?: string;
    }
  | {
      page: "field";
      field: string;
      filterParams?: Record<string, string>;
      title?: string;
    }
  | {
      page: "package";
      packageSlug?: string | undefined | null;
      title?: string;
    }
  | {
      page: "buy";
      params: any;
      title?: string;
    }
  | {
      page: "promotion";
      action: PromotionActionWithTitle | undefined;
      title?: string;
    };

interface State {
  actionHandlers: ActionHandlers;

  setHandlers: (handlers: ActionHandlers) => void;

  getDataHandlers: GetDataHandlers;
  setDataHandlers: (handlers: GetDataHandlers) => void;

  previousPathname: string | undefined;
  previousQuery: Record<string, string>;
  setPreviousRoute: ({
    previousPathname,
    previousQuery,
  }: {
    previousPathname: string | undefined;
    previousQuery: Record<string, string>;
  }) => void;

  Link: LinkComponent;

  initiateLink: (link: LinkComponent) => void;
}

export const useHallActions = create<State>()(
  immerMiddleware((set, get) => ({
    actionHandlers: {
      goToSearchPage: () => {
        console.error("action not initiated");
      },
      goToHall: () => {
        console.error("action not initiated");
      },
      goToCounselorPage: () => {
        console.error("action not initiated");
      },
      goToPackagePage: () => {
        console.error("action not initiated");
      },
      goToBuyPage: () => {
        console.error("action not initiated");
      },
      goToFieldPage: () => {
        console.error("action not initiated");
      },
      goToMyCounselorsPage: () => {
        console.error("action not initiated");
      },
      goToCategories: () => {
        console.error("action not initiated");
      },
      onPromotionClick: () => {
        console.error("action not initiated");
      },
      onServiceClick: () => {
        console.error("action not initiated");
      },
      goToCounselorChatPage: () => {
        console.error("action not initiated");
      },
      backToPrevious: () => {
        console.error("action not initiated");
      },
      getPageLink: () => {
        console.error("action not initiated");
      },
      getCounselorPackageSlug: () => {
        console.error("action not initiated");
      },
    },

    setHandlers: (handlers) => {
      set((state) => {
        state.actionHandlers = handlers;
      });
    },

    getDataHandlers: {
      getField: () => {
        console.error("action not initiated");
      },
    },
    setDataHandlers: (handlers) => {
      set((state) => {
        state.getDataHandlers = handlers;
      });
    },

    previousPathname: undefined,
    previousQuery: {},
    setPreviousRoute: ({ previousPathname, previousQuery }) => {
      set((state) => {
        state.previousPathname = previousPathname;
        state.previousQuery = previousQuery;
      });
    },

    Link: ({ children }) => {
      return <>{children({ onClick: () => {} })}</>;
    },

    initiateLink: (link) => {
      set((state) => {
        state.Link = link;
      });
    },
  })),
);
